import { render, staticRenderFns } from "./rating-5.vue?vue&type=template&id=30bcd18e&"
import script from "./rating-5.vue?vue&type=script&lang=js&"
export * from "./rating-5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports